<template>
  <div>
    <v-chip color="indigo"
            class="mr-2"
            size="small"
    >
      <AppSignatureTypeText :provider="envelopeTemplate.provider" :signature-type="envelopeTemplate.signatureType"/>
    </v-chip>
    <v-chip color="pink"
            class="mr-2"
            size="small"
    >
      <AppProviderText :provider="envelopeTemplate.provider"/>
    </v-chip>
    <v-chip v-if="envelopeTemplate.envelopeType === 'multiple'"
            color="cyan"
            class="mr-2"
            size="small"
    >
      {{ $t('common.envelopeType.multiple') }}
    </v-chip>
  </div>
</template>

<script>

import AppProviderText from '@/common/AppProviderText.vue'
import AppSignatureTypeText from '@/common/AppSignatureTypeText.vue'

export default {
  name: 'Type',
  components: { AppProviderText, AppSignatureTypeText },
  props: {
    envelopeTemplate: {
      type: Object,
      required: true,
    },
  },
}
</script>
